import React, { useState, useRef, useEffect, useLayoutEffect } from "react";
import l from "components/util/l";

function CollectionTab({
  index,
  tableRef,
  collection,
  activeCollectionId,
  onClickTab,
  onDoubleClickTab,
}) {

  const containerRef = useRef(null);
  const menuRef = useRef(null);

  const [menu, setMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
  });

  const onContextMenu = (e) => {

    e.preventDefault();
    e.stopPropagation();

    const cont = containerRef.current;
    if (!cont) return;

    const rect = cont.getBoundingClientRect();
    let relX = e.clientX - rect.left;
    let relY = e.clientY - rect.top;

    setMenu({ visible: true, x: relX, y: relY });

  }

  const onClickHideMenu = () =>
    menu.visible && setMenu((s) => ({ ...s, visible: false }));

  const onClickDOM = (ev) => {
    const target = ev.target;
    if (
      menu.visible &&
      menuRef.current &&
      !menuRef.current.contains(target) &&
      containerRef.current &&
      !containerRef.current.contains(target)
    ) {
      setMenu((s) => ({ ...s, visible: false }));
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", onClickDOM);
    return () => {
      document.removeEventListener("mousedown", onClickDOM);
    };
  }, [menu.visible]);

  useLayoutEffect(() => {

    if (!menu.visible) return;

    const menuEl = menuRef.current;
    const cont = containerRef.current;
    if (!menuEl || !cont) return;

    const menuRect = menuEl.getBoundingClientRect();
    const contRect = cont.getBoundingClientRect();

    let left = menu.x;
    let top = menu.y;

    const maxLeft = Math.max(0, contRect.width - menuRect.width);
    if (left > maxLeft) left = maxLeft;

    const spaceBelow = contRect.height - top;
    if (menuRect.height > spaceBelow)
      top = top - menuRect.height;

    if (left !== menu.x || top !== menu.y)
      setMenu((s) => ({ ...s, x: left, y: top }));

  }, [menu.visible, menu.x, menu.y]);

  const {
    showImport,
    showExport,
    showManageCollections,
    showPermissions,
    isReadOnly,
    setIsImportModalShown,
    setIsExportModalShown,
    setIsCloneModalShown,
    onClickOpenCollectionEditModal,
    onClickOpenPermissionModal,
    onClickDeleteCollection,
  } = tableRef.current || {};

  return (
    <div ref={containerRef} className="position-relative" onClick={onClickHideMenu}>
      <a
        id={`collection-tab-${collection.id}`}
        key={`collection-tab-${index}`}
        className={
          "btn collection-tab d-flex align-items-center ml-2 px-3 py-0 " +
          (activeCollectionId == collection.id ? "active" : "")
        }
        onContextMenu={onContextMenu}
        onClick={onClickTab}
        onDoubleClick={onContextMenu}
      >
        <span className="text-truncate py-2">
          {collection?.uiSettings?.label ?? collection.name}
        </span>
      </a>



      {menu.visible && (
        <div
          id={`table-options-collection-${collection.id}`}
          ref={menuRef}
          className="dropdown-menu show"
          style={{
            position: "fixed",
            top: (containerRef.current?.getBoundingClientRect().top ?? 0) + menu.y - 40,
            left: (containerRef.current?.getBoundingClientRect().left ?? 0) + menu.x,
            zIndex: 2000,
          }}
        >

          {
            !isReadOnly && showManageCollections && (
              <button
                type="button"
                onClick={onClickOpenCollectionEditModal}
                className="dropdown-item"
              >
                <i className="fas fa-edit dropdown-item-icon mr-2"></i> {l("Editar tabla%CA019")}
              </button>
            )
          }

          {
            showPermissions && (
              <div>
                <button
                  type="button"
                  onClick={onClickOpenPermissionModal}
                  className="dropdown-item"
                >
                  <i className="fas fa-user-shield dropdown-item-icon mr-2"></i>
                  {l("Ver permisos%CA152")}
                </button>
              </div>
            )}

          <hr className="my-2" />

          {showImport && (
            <button
              type="button"
              className="dropdown-item"
              onClick={() => setIsImportModalShown(true)}
            >
              <i className="fas fa-file-import dropdown-item-icon mr-2"></i>
              {l("Cargar excel%CA101")}
            </button>
          )}

          {showExport && (
            <button
              type="button"
              className="dropdown-item"
              onClick={() => setIsExportModalShown(true)}
            >
              <i className="fas fa-download dropdown-item-icon mr-2"></i>
              {l("Descargar datos%CA009")}
            </button>
          )}






          {
            !isReadOnly && showManageCollections && (
              <div>
                <hr className="my-2" />
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => setIsCloneModalShown(true)}
                >
                  <i className="fas fa-copy dropdown-item-icon mr-2"></i>
                  {l("Duplicar%CA007")}
                </button>
              </div>
            )
          }

          {
            !isReadOnly && showManageCollections && (
              <button
                type="button"
                className="dropdown-item"
                onClick={onClickDeleteCollection}>
                <i className="fas fa-trash dropdown-item-icon mr-2"></i>
                {l("Eliminar%GA001")}
              </button>
            )
          }

        </div>
      )}
    </div>
  );
}

export default CollectionTab;